import useFixaLocation from "@coworker/apprestructured/src/shared/wrappers/FixaLocation/useFixaLocation";
import { useTranslation } from "@coworker/locales";
import styles from "./tab-navigation.module.css";
import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import trackerHelper from "@coworker/app/src/helpers/tracker";

const TabNavigation = () => {
  const location = useFixaLocation();
  const { t } = useTranslation();
  const navigate = useFixaNavigate();

  const tabs = [
    {
      label: t("homeString"),
      href: "/home",
      testId: "homeTabbedNavigationButton",
    },
    {
      label: t("TasksString"),
      href: "/tasks",
      testId: "tasksTabbedNavigationButton",
    },
  ];

  return (
    <div className={styles["tab-container"]}>
      {tabs.map((tab) => {
        const isActive = tab.href === location.pathname;

        return (
          <div
            className={styles["tab-wrapper"]}
            key={tab.label}
            data-testid={tab.testId}
          >
            <div
              onClick={() => {
                navigate(tab.href);
                trackerHelper.trackMainHeaderNavigationLinksClick(tab.label);
              }}
              className={styles[isActive ? "tab-active" : "tab"]}
            >
              {tab.label}
            </div>
            {isActive && <div className={styles["bottom-border"]} />}
          </div>
        );
      })}
    </div>
  );
};

export default TabNavigation;
